import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    // 存储token
    Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
    userinfo:localStorage.getItem('userinfo') ? localStorage.getItem('userinfo') : '',
  },
  mutations: {
    // 修改token，并将token存入localStorage
    loginStatus(state, user) {
      state.Authorization = user.Authorization;
      state.AuthorExpireTime = user.AuthorExpireTime;
      localStorage.setItem('Authorization', user.Authorization);
      localStorage.setItem('AuthorExpireTime', user.AuthorExpireTime);
    },
    userInfo(state, user) {
      state.userinfo = user;
      localStorage.setItem('userinfo', JSON.stringify(user));
    },
    testlo(){
      console.log("success")
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/utils/store.js